<div class="language-dropdown">
    <i [nzDropdownMenu]="menu" [nzPlacement]="'bottomLeft'" nz-dropdown nzTrigger="click">
        <!--<i [nzTheme]="'outline'" [nzType]="'global'" class="color-blue" nz-icon></i>-->
        <i class="country" nz-icon>
            <img src="assets/country-flags/4x3/{{ currentLanguage | async }}.svg">
        </i>
    </i>
    <nz-dropdown-menu #menu="nzDropdownMenu" class="language-menu">
        <ul nz-menu>
            <li (click)="changeLanguage('de_DE')" class="language-menu-item" nz-menu-item>
                <img src="assets/country-flags/4x3/de.svg">
                <span>{{ "global.translation.german" | translate }}</span>

            </li>
            <li (click)="changeLanguage('en_US')" class="language-menu-item" nz-menu-item>
                <img src="assets/country-flags/4x3/en.svg">
                <span>{{ "global.translation.english" | translate }}</span>
            </li>
        </ul>
    </nz-dropdown-menu>
</div>
